import { router$ } from '@/router/router$';
import { publishBehavior, map, refCount } from 'rxjs/operators';

export const productsWithoutOrderingFeatureEnabled$ = router$.pipe(
  map((route) => {
    return route && route.name.indexOf('assortiment') === 0;
  }),
  publishBehavior(false),
  refCount()
);
